<script setup>
import PrintBatchLabelModal from "../components/PrintBatchLabel.vue";
</script>
<style>
.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.total-rows {
  padding: 10px;
  font-weight: bold;
}
</style>
<template>
    <div class="card">
      <div class="card-header pb-0">
        <h6>Batch Profile table</h6>
        <div class="row">
            <div class="col-md-3">
              <label for="example-text-input" class="form-control-label">Quick Search</label>
              <input
                type="text"
                v-model="searchQuery"
                placeholder="Search..."
                class="form-control mb-3"
                style="max-width: 250px; "
              />
            </div>
            <div class="col-md-3">
                <label for="example-text-input" class="form-control-label">Block ID</label>
                <select class="form-control" v-model="search.blockid">
                  <option value="%">All</option>
                  <option v-for="(item,index) in model.batchblockid" :key="index" :value="item.batchblockid">
                      {{ item.batchblockid }} - {{ item.blockname }}
                  </option>
                </select>
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Status</label>
                <select class="form-control" v-model="search.status">
                    <option value="%">All</option>
                    <option value="0">Open</option>
                    <option value="1">Closed</option>
                    <option value="2">Hold</option>
                    <option value="3">Cancel</option>
                </select>
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label">Product</label>
                <select class="form-control" v-model="search.product">
                    <option value="%">All</option>
                    <option value="SW">Sawit</option>
                    <option value="GT">Getah</option>
                    <option value="DR">Durian</option>
                    <option value="KK">Koko</option>
                </select>
            </div>
            <div class="col-md-2">
                <label for="example-text-input" class="form-control-label" style="width: 100%;">&nbsp;</label>
                <button class="btn btn-success " style="float:right;" id="btn_search" @click="getBatchProfile">Search</button>
            </div>
        </div>
        <hr />
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0" style="width:100%">
            <thead>
              <tr>
                <th
                  class="text-uppercase text-weight-bold font-weight-bolder">
                  Batch
                </th>
                <th
                  class="text-uppercase text-weight-bold font-weight-bolder ps-2">
                  Product
                </th>
                <th
                  class="text-uppercase text-weight-bold font-weight-bolder ps-2">
                  Quantity
                </th>
                <th
                class="text-uppercase text-weight-bold font-weight-bolder ps-2">
                  Date
                </th>
                <th
                class="text-uppercase text-weight-bold font-weight-bolder ps-2">
                  Status
                </th>
                <th class="text-secondary opacity-7"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in paginatedBatchProfile" :key="index">
                <td class="align-middle" style="max-width: 20%; width: 20%; white-space: normal; word-wrap: break-word;">
                  <div class="d-flex px-2 py-1">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-0 text-sm">{{ ((currentPage-1)* perPage) + index +1 }}. {{ item.batchno }}</h6>
                      <p class="text-xs text-weight-bold  mb-0">
                        {{ item.block}}
                      </p>
                    </div>
                  </div>
                </td>
                <td class="align-middle" style="max-width: 20%; width: 20%; white-space: normal; word-wrap: break-word;">
                  <h6 class="text-xs font-weight-bold mb-0">{{ item.clone }}</h6>
                  <p class="text-xs text-weight-bold  mb-0">{{ item.product }}</p>
                </td>
                <td class="align-middle" style="max-width: 20%; width: 20%; white-space: normal; word-wrap: break-word;">
                  <p class="text-xs font-weight-bold mb-0">Init: {{ item.quantity }} pokok</p>
                  <h6 class="text-xs font-weight-bold mb-0">Cur: {{ item.curquantity }} pokok</h6>
                </td>
                <td class="align-middle" style="max-width: 20%; width: 20%; white-space: normal; word-wrap: break-word;">
                  <p class="text-xs font-weight-bold mb-0">Semai: {{ item.datesemai }}</p>
                  <p class="text-xs font-weight-bold mb-0">Alih: {{ item.datealih }}</p>
                  <p class="text-xs font-weight-bold mb-0">{{ item.remark }}</p>
                </td>
                <td class="align-middle" style="max-width: 10%; width: 10%; white-space: normal; word-wrap: break-word;">
                  <span v-if="item.status == 'Open'" class="badge badge-sm bg-gradient-success text-xs">{{ item.status}}</span>
                  <span v-else-if="item.status == 'Closed'" class="badge badge-sm bg-gradient-primary text-xs">{{ item.status}}</span>
                  <span v-else class="badge badge-sm bg-gradient-info text-xs">{{ item.status}}</span>
                </td>
                <td class="align-middle" style="max-width: 10%; width: 10%; white-space: normal; word-wrap: break-word;">
                  <RouterLink :to="{path : '/editBatch/'+ item.batchno}"
                    href="javascript:;"
                    class="btn btn-success"
                    data-toggle="tooltip"
                    data-original-title="Edit Batch"
                    >Edit
                  </RouterLink>
                  <button class="btn btn-primary" @click="openModal(item.batchno)">Print</button>
                </td>
              </tr>
              
            </tbody>
          </table>
          <hr />
          <div class="pagination-container">
            <div>
              <button @click="prevPage" :disabled="currentPage === 1" class="btn btn-info">Previous</button>
              <span class="form-control-label" style="padding:10px"> Page {{ currentPage }} of {{ totalPages }} </span>
              <button @click="nextPage" :disabled="currentPage === totalPages" class="btn btn-info">Next</button>
            </div>
            
            <span class="form-control-label total-rows">Total {{ totalRows }} entries </span>
          </div>
        </div>
      </div>
    </div>
      
  <div class="mt-4 row">
      <PrintBatchLabelModal :id="label.batchno" :key="componentKey2">
      </PrintBatchLabelModal>
  </div>
  </template>

  
<script>
import axios from 'axios';
import { Modal } from 'bootstrap';

export default {
  name:'batchProfileSelect',
  components:{
    PrintBatchLabelModal,
  },
  data(){
    return {
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      componentKey2: 0,
      searchQuery:'',
      label:{
        batchno:'',
      },
      model:{
        batchProfile: [],
        batchblockid: [],
      },
      search:{
          status:"%",
          product:"%",
          blockid: "%",
        }
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.model.batchProfile.length / this.perPage);
    },
    paginatedBatchProfile() {
      const start = (this.currentPage - 1) * this.perPage;
      let query = this.searchQuery.toLowerCase();

      // Filter customers by checking all properties in each row
      let filtered = this.model.batchProfile.filter(item => {
        return Object.values(item).some(value =>
          String(value).toLowerCase().includes(query)
        );
      });
      return filtered.slice(start, start + this.perPage);
    }
  },
  mounted(){
    this.getBatchProfile();
    this.listAllBatchBlockId();
    this.myModal = new Modal(document.getElementById('PrintLabelModal'));
  },
  methods: {
    openModal(id){
      this.label.batchno = id;
      this.myModal.show();
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    getBatchProfile(){
      var blockid = '%';
        if(this.search.blockid != ''){
            blockid = this.search.blockid;
        }
        axios.get('nursery/listAllNurseryBatch/' + blockid + "/" + this.search.status + "/" +  this.search.product)
            .then(res => {
              console.log(res.data.batchlist);
              this.model.batchProfile = res.data.batchlist;
              this.totalRows = res.data.batchlist.length;
              this.currentPage = 1;
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
    },
    listAllBatchBlockId(){
      console.log('nursery/listAllBatchBlockId','Table');
        axios.get('nursery/listAllBatchBlockId')
            .then(res => {
              this.model.batchblockid = res.data.batchblockid;
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
    }
  },
}
</script>
  